import { Autocomplete, Box, IconButton, TextField } from '@mui/material';
import React, { useState, useEffect, useRef, memo } from 'react';
import './styles/_comboBoxCustom.scss';
import Images from 'shared/assets/index';

interface Props {
  handleChange: (value: any, idsDoc?: number[], params?: any) => void;
  placeholder: string;
  data: any[];
  idsDoc?: number[];
  currentValue?: any;
  isDisabled?: boolean;
  focusSelected?: boolean;
  useButtonIcon?: boolean;
  idComboBoxCustom?: string;
  isReadOnly?: boolean;
  defaultValue?: string;
  inputFieldState?: {
    isReadOnly: boolean;
    defaultValue: string;
  },
  params?: any;
}

export const ComboBoxCustom = memo(({ handleChange, placeholder, data, idsDoc, currentValue, isDisabled, focusSelected, useButtonIcon, inputFieldState, params }: Props) => {
  const comboBoxRef = useRef<HTMLInputElement>(null);
  const [selectedValue, setSelectedValue] = useState(null);
  const [openComboBox, setOpenComboBox] = useState(false);
  
  const handleInputChange = (event: any, newValue: any) => {
    focusSelected && setSelectedValue(newValue);
    (newValue || event.target.textContent.length < 1) && handleChange(newValue, idsDoc, params);
  };
  
  useEffect(() => {
    if (openComboBox) {
      comboBoxRef.current?.focus();
    }
  }, [openComboBox])

  useEffect(() => {
    if (inputFieldState?.defaultValue) {
      const defaultOption = data.find(
        (option) => option.name === inputFieldState.defaultValue
      );
      
      if (defaultOption) {
        setSelectedValue(defaultOption);
        handleChange(defaultOption, idsDoc);
      }
    }
  }, [inputFieldState, data]);

  return (
    <span className='combobox-container' data-testid="container-combobox">
      {
        useButtonIcon ?
          <>
            <IconButton
              className='button-show-combobox'
              data-testid="btn-show-combobox"
              disabled={!!isDisabled}
              onClick={() => {
                setOpenComboBox(true);
              }}
            >
              <img className='show-combobox-image' src={Images.iconoAsignarUsuario} alt="Mostrar comboBox" />
            </IconButton>
            {
              openComboBox && !isDisabled &&
              <Box className='combobox'>
                <Autocomplete
                  open={openComboBox}
                  onBlur={() => { setOpenComboBox(false) }}
                  disablePortal={false}
                  disabled={!!isDisabled}
                  data-testid="combo-box-custom"
                  popupIcon
                  options={data}
                  className={`combobox-custom ${inputFieldState?.isReadOnly && 'readOnly'}`}
                  getOptionLabel={(option) => option.name}
                  value={selectedValue}
                  onChange={handleInputChange}
                  renderInput={(params) => <TextField {...params} inputRef={comboBoxRef} placeholder={currentValue?.name || placeholder} data-testid="search_comboBox" />}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  noOptionsText="No se encontró sugerencias"

                  slotProps={{
                    clearIndicator: {
                      onClick: () => { 
                        handleChange('', idsDoc)
                        setSelectedValue(null)
                      }
                    },
                    popper: {
                      style: {
                        zIndex: 10000
                      },
                      sx: {
                        '& .MuiAutocomplete-listbox .MuiAutocomplete-option': {
                          fontSize: 'clamp(0.75rem, 0.3042rem + 1.48vw, 0.875rem) !important',
                          lineHeight: 1.4,
                          padding: '8px 12px'
                        }
                      }
                    }
                  }}
                  readOnly={inputFieldState?.isReadOnly}
                />
              </Box>
            }
          </> :
          <Autocomplete
            disablePortal={false}
            disabled={!!isDisabled}
            data-testid="combo-box-custom"
            options={data}
            className={`combobox-custom ${inputFieldState?.isReadOnly && 'readOnly'}`}
            getOptionLabel={(option) => option.name}
            value={selectedValue}
            onChange={handleInputChange}
            renderInput={(params) => <TextField {...params} placeholder={ currentValue?.name || placeholder } data-testid="search_comboBox" />}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            noOptionsText="No se encontró sugerencias"

            slotProps={{
              clearIndicator: {
                onClick: () => {
                  handleChange('', idsDoc)
                  setSelectedValue(null)
                }
              },
              popper: {
                style: {
                  zIndex: 10000
                },
                sx: {
                  '& .MuiAutocomplete-listbox .MuiAutocomplete-option': {
                    fontSize: 'clamp(0.75rem, 0.3042rem + 1.48vw, 0.875rem) !important',
                    lineHeight: 1.4,
                    padding: '8px 12px'
                  }
                }
              }
            }} 
            readOnly={inputFieldState?.isReadOnly}
        />
      }
    </span>
  )
})
